export async function changeTemplate(template) {
    // switch template
    await $w('#templatesMultiState').changeState(`template${template}`);
}